import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export const useColorList = () => {
  const colorList = useSelector((state) => {
    return state.colorList.data;
  });

    const getColorById = useCallback(
    (colorId) => {
      const id = colorId?.value ?? colorId;
      const found = colorList.find((color) => String(color.id) === String(id));
      return found?.color ?? null;
    },
    [colorList]
  );

  const getIdByColor = useCallback(
    (hexColor, defaultColor = colorList?.[0]?.id) => {
      const selectedId = colorList.find((color) => hexColor === color.color)?.id;
      if (selectedId == null && defaultColor != null) {
        return defaultColor;
      }
      return selectedId;
    },
    [colorList],
  );

  return { colorList, getColorById, getIdByColor };
};

